import { API_ROOT_URL } from "../config";
import axios from 'axios';

export const contactUsService = {
  contactUs,
  
};


function contactUs(name, email, subject, description) {
  const token = JSON.parse(localStorage.getItem("token"));
  const obj = {    
    "username": name, // not required
    "email": email, // not required
    "subject": subject, // required
    "description": description
};
const requestOptions = {
  method: "POST",
  headers: { "Content-Type": "application/json"},
 
  body: JSON.stringify(obj)
}
if(token)
  requestOptions.headers['Authorization'] = `Bearer ${token}`;
  

  return fetch(`${API_ROOT_URL}/projects/contact-us/`, requestOptions).then(handleResponse => {
    return handleResponse;
  });
}










// WEBPACK FOOTER //
// ./src/services/contactUs.service.js